import { WebApi } from '@/services/WebApi'

const state = () => ({
  postId: '',
  openSlots: [],
  loadingOpenSlots: false
})

const mutations = {
  setPostId (state, postId) {
    state.postId = postId
  },
  setOpenSlots (state, openSlots) {
    state.openSlots = openSlots
  },
  setLoadingOpenSlots (state, value) {
    state.loadingOpenSlots = !!value
  },
  resetOpenSlots (state) {
    state.postId = ''
    state.openSlots = []
  }
}

const actions = {
  fetchOpenSlots ({ commit }, { siteId, postId }) {
    commit('setPostId', postId)
    return new Promise((resolve, reject) => {
      commit('setLoadingOpenSlots', true)
      WebApi.get('Portal/' + siteId + '/OpenSlot/Post/' + postId + '/Available')
        .then(response => {
          commit('setOpenSlots', response.data)
          resolve(response)
        })
        .catch(error => {
          commit('setOpenSlots', [])
          reject(error)
        })
        .finally(() => commit('setLoadingOpenSlots', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
